export function remove<T>(array: T[], item: T): void {
  const indexOfItem = array.indexOf(item);
  if (indexOfItem === -1) {
    return;
  }
  array.splice(indexOfItem, 1);
}
